export const formOrderObjFromCart = (data = null) => {
    const catalogService = data?.itemDetail?.catalogService || null;
    const environmentDetails = data?.itemDetail?.catalogService?.catalogConfig?.environmentDetails || null;
    const catalogConfig = data?.itemDetail?.catalogService?.catalogConfig || null;
    const entityDetails = data?.itemDetail?.entityDetails || null;
    return {
        // Application Section
        appProfile: environmentDetails?.businessService || entityDetails?.name || null,
        entityDetails: null,
        sector: catalogService?.sector || null,
        sectorDetail: null,
        environment: environmentDetails?.environment || null,
        landingZoneDetails: null,
        region: environmentDetails?.dtc || environmentDetails?.location || 'Dallas Data Center',
        dtc: environmentDetails?.dtc || 'Dallas Data Center',
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter },
        }),
        appOwner: `${environmentDetails?.applicationManagerGpid} - ${environmentDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${environmentDetails?.applicationManagerGpid} - ${environmentDetails?.applicationManager}`,
            gpid: environmentDetails?.applicationManagerGpid,
            name: environmentDetails?.applicationManager,
            email: environmentDetails?.applicationManagerEmail,
        },
        appTier: environmentDetails?.applicationTier || null,
        appTierCode: environmentDetails?.appTierCode || null,
        businessCategory: catalogConfig?.tags?.['pep-business-category'] || null,
        dataClassification: catalogConfig?.tags?.['pep-dataclassification'] || null,

        // Resource Section
        clusterDetails: catalogConfig?.clusterType || null,
        clusterName: catalogConfig?.clusterName || null,
        vlanDetails: catalogConfig?.vlanType || null,
        vlanName: catalogConfig?.vlanName || null,
        osImage: catalogConfig?.os?.osName || null,
        osName: catalogConfig?.os?.osName || null,
        osDisplayName: catalogConfig?.os?.osDisplayName || null,
        cpu: catalogConfig?.cpu || null,
        memoryGiB: catalogConfig?.memoryGiB || null,
        quantity: catalogService?.quantity || null,
        maxDataDiskCount: 8,
        dataDisksCount: catalogConfig?.diskDefinitions?.length || null,
        dataDisks: catalogConfig?.diskDefinitions || [],
        defaultDataDisks: [],
        timeZone: catalogService?.timeZone || null,
        displayTimeZone: catalogService?.displayTimeZone || null,
        billingEntity: catalogConfig?.billingEntity || null,
        billingEntityDetails: null,

        // Access Management Section
        domain: environmentDetails?.domain || null,
        adous: environmentDetails?.adOu ? { fullpath: environmentDetails?.adOu } : null,
        adousDetails: environmentDetails?.adOu ? { fullpath: environmentDetails?.adOu } : null,
        samAccountId: catalogConfig?.samAccountId || null,
        catalogCode: catalogService?.catalogServiceCode,
        catalogType: catalogService?.catalogType,
        cloudProvider: catalogService?.cloudProvider,
        cloudService: catalogService?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;
    const entityDetails = data?.entityDetails || null;

    return {
        // Application Section
        appProfile: environmentDetails?.businessService || entityDetails?.name || null,
        entityDetails: null,
        sector: catalog?.sector || null,
        sectorDetail: null,
        environment: environmentDetails?.environment || null,
        landingZoneDetails: null,
        region: environmentDetails?.dtc || environmentDetails?.location || 'Dallas Data Center',
        dtc: environmentDetails?.dtc || 'Dallas Data Center',
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter },
        }),
        appOwner: `${environmentDetails?.applicationManagerGpid} - ${environmentDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${environmentDetails?.applicationManagerGpid} - ${environmentDetails?.applicationManager}`,
            gpid: environmentDetails?.applicationManagerGpid,
            name: environmentDetails?.applicationManager,
            email: environmentDetails?.applicationManagerEmail,
        },
        appTier: environmentDetails?.applicationTier || null,
        appTierCode: environmentDetails?.appTierCode || null,
        businessCategory: catalogConfig?.tags?.['pep-business-category'] || null,
        dataClassification: catalogConfig?.tags?.['pep-dataclassification'] || null,

        // Resource Section
        clusterDetails: catalogConfig?.clusterType || null,
        clusterName: catalogConfig?.clusterName || null,
        vlanDetails: catalogConfig?.vlanType || null,
        vlanName: catalogConfig?.vlanName || null,
        osImage: catalogConfig?.os?.osName || null,
        osName: catalogConfig?.os?.osName || null,
        osDisplayName: catalogConfig?.os?.osDisplayName || null,
        cpu: catalogConfig?.cpu || null,
        memoryGiB: catalogConfig?.memoryGiB || null,
        quantity: catalog?.quantity,
        maxDataDiskCount: 8,
        dataDisksCount: catalogConfig?.diskDefinitions?.length || null,
        dataDisks: catalogConfig?.diskDefinitions || [],
        defaultDataDisks: [],
        timeZone: catalog?.timeZone || null,
        displayTimeZone: catalog?.displayTimeZone || null,
        billingEntity: catalogConfig?.billingEntity || null,
        billingEntityDetails: null,

        // Access Management Section
        domain: environmentDetails?.domain || null,
        adous: environmentDetails?.adOu ? { fullpath: environmentDetails?.adOu } : null,
        adousDetails: environmentDetails?.adOu ? { fullpath: environmentDetails?.adOu } : null,
        samAccountId: catalogConfig?.samAccountId || null,
        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};
export const resetOrder = {
    // Application Section
    appProfile: null,
    entityDetails: null,
    sector: null,
    sectorDetail: null,
    environment: null,
    landingZoneDetails: null,
    region: 'Dallas Data Center',
    dtc: 'Dallas Data Center',
    hCode: null,
    hCodeDetails: null,
    appOwner: null,
    appOwnerDetails: null,
    appTier: null,
    appTierCode: null,
    businessCategory: null,
    dataClassification: null,

    // Resource Section
    clusterDetails: null,
    clusterName: null,
    vlanDetails: null,
    vlanName: null,
    osImage: null,
    osName: null,
    osDisplayName: null,
    cpu: null,
    memoryGiB: null,
    quantity: 1,
    maxDataDiskCount: 8,
    dataDisksCount: null,
    dataDisks: [],
    defaultDataDisks: [],
    timeZone: null,
    displayTimeZone: null,
    billingEntity: null,
    billingEntityDetails: null,

    // Access Management Section
    domain: null,
    adous: null,
    adousDetails: null,
    samAccountId: null,

    tags: [],
    estimatedCost: {
        details: [],
        qty: null,
        totalOneTimeCost: {
            frequency: 'one time',
            estCost: null,
            currency: 'USD',
        },
        totalRecurringCost: {
            frequency: 'monthly',
            estCost: null,
            currency: 'USD',
        },
        notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
    },
    placeNewOrder: new Date(),
    validationStatus: 'clearValidation',
    isTouched: false,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isTagOpen: false,
    isApplicationOpen: false,
    isSubmitOrderSuccess: false,
    isUpdatedToCart: false,
    isCostSplitOpen: false,
    isDiskOpen: false,
    isDataDisk: { isOpen: false, newDataDiskCount: 0, deleteCount: 0 },
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'monthly',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const getDataDiskSize = (data) => {
    const size = data?.values[0]?.possibleValues || [];
    return size.map((item) => item);
};

export const isValidMountPoint = (disableField, mountPt) => {
    let result = true;
    if (!disableField) {
        // result = mountPt?.charAt(0) === '/';
        result = /^\/(?:[a-zA-Z0-9_-]+\/?)*$/?.test(mountPt);
    }
    return result;
};

export const ispgthanaFormValid = (dataDisks, reservedPaths) => {
    let errorCount = 0;
    let isDataDiskValid = false;
    if (dataDisks?.length) {
        dataDisks?.forEach((disk) => {
            if (
                !(
                    (disk?.disableFields &&
                        disk.diskSizeInGib !== '' &&
                        disk.diskType !== '' &&
                        disk.diskCount !== '' &&
                        disk.diskCount !== 0 &&
                        (disk?.diskTier && disk?.diskTier !== null ? /^[0-9]+$/.test(disk.diskCount) : true) &&
                        disk.diskCount !== '0' &&
                        disk.totalSize !== undefined &&
                        disk.totalSize !== '') ||
                    (!disk?.disableFields &&
                        disk.diskSizeInGib !== '' &&
                        disk.diskType !== '' &&
                        disk.mountPoint !== '' &&
                        disk.mountPoint !== undefined &&
                        disk.fsType !== '' &&
                        !reservedPaths?.includes(disk.mountPoint) &&
                        isValidMountPoint(disk?.disableFields, disk?.mountPoint))
                )
            ) {
                // eslint-disable-next-line no-plusplus
                errorCount++;
            }
        });
    }
    isDataDiskValid = errorCount === 0;
    return isDataDiskValid;
};

export const isMountPointDuplicate = (dataDisks) => {
    const mountPointsArray = dataDisks?.filter((disk) => disk?.mountPoint && disk?.mountPoint)?.map((d) => d?.mountPoint) || [];
    return new Set(mountPointsArray)?.size !== mountPointsArray?.length;
};

export const checkMountPointExists = (mountPoint, disableFields = false, reservedPaths = []) => {
    if (!disableFields) {
        const mountPoints = reservedPaths || [];
        // const expression=/^\/[a-zA-Z][a-zA-Z0-9_-]*$/;
        let ValidMountPoint = { shhowMessage: false, message: null };
        if (mountPoint && (mountPoint !== '' || mountPoint !== null)) {
            if (!/^\/(?:[a-zA-Z0-9_-]+\/?)*$/?.test(mountPoint)) {
                ValidMountPoint = { shhowMessage: true, message: 'should start with / followed by alphabet ' };
            } else if (mountPoints.indexOf(mountPoint) > -1) {
                ValidMountPoint = {
                    shhowMessage: true,
                    message: `following paths are reserved
                ${reservedPaths?.join(', ')}`,
                };
            } else {
                ValidMountPoint = { shhowMessage: false, message: null };
            }
        }
        return ValidMountPoint;
    }
    return '';
};

export const costPayload = ({ order = [], catalogCode }) => {
    return {
        catalogServiceCode: catalogCode,
        quantity: order?.quantity,
    };
};
